import React from 'react';
import ReactDOM from 'react-dom';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { setupConfig, isPlatform } from '@ionic/react';
import { SplashScreen } from '@capacitor/splash-screen';
import App from './App';
// import * as serviceWorker from './serviceWorker';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.scss';

setupConfig({
    mode: 'ios',
    animated: !isPlatform('desktop'),
    hardwareBackButton: false,
});

//TODO: Ha kijön az ionic 5.0.8 vagy újabb akkor ezt ki lehet venni.
window.addEventListener('keyboardDidShow', (e) => {
    window.dispatchEvent(new Event('resize')); //temporary scroll-assist fix
}, false);

ReactDOM.render(<App />, document.getElementById('root'));
SplashScreen.hide();

defineCustomElements(window);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
